import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type AppTheme = 'light' | 'dark';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private currentThemeSubj = new BehaviorSubject<AppTheme>('light');
  public theme$ = this.currentThemeSubj.asObservable();

  init(): void {
    const savedTheme = (localStorage.getItem('theme') as AppTheme) || 'light';
    this.set(savedTheme);
  }

  set(theme: AppTheme): void {
    localStorage.setItem('theme', theme);
    const root = document.documentElement;
    if (theme === 'dark') {
      root.classList.add('dark-mode');
    } else {
      root.classList.remove('dark-mode');
    }
    this.currentThemeSubj.next(theme);
  }

  toggle(): void {
    const next = this.currentThemeSubj.value === 'dark' ? 'light' : 'dark';
    this.set(next);
  }

  isDark(): boolean {
    return this.currentThemeSubj.value === 'dark';
  }
}
